import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { ctaData, navData } from "../../data/mockData";

const CTASection = ({ scrollToQuote }) => {
  return (
    <section className="py-20 bg-gradient-to-br from-sky-600 to-sky-700 text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-8">
        <h3 className="text-3xl md:text-4xl font-bold">{ctaData.title}</h3>
        <p className="text-xl text-sky-100">{ctaData.subtitle}</p>
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href={`tel:${navData.phoneLink}`}
            className="inline-flex items-center bg-white text-sky-600 hover:bg-sky-50 font-medium text-lg px-8 py-3 rounded-md shadow transition-colors"
          >
            <Phone className="w-5 h-5 mr-2" />
            Call NeatWave: {navData.phone}
          </a>
          <button
            onClick={scrollToQuote}
            className="inline-flex items-center border-2 border-white text-white hover:bg-white hover:text-sky-600 font-medium text-lg px-8 py-3 rounded-md transition-colors"
          >
            Get a Free Quote
          </button>
          <a
            href={navData.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-green-600 hover:bg-green-700 text-white font-medium text-lg px-8 py-3 rounded-md shadow transition-colors"
          >
            <MessageCircle className="w-5 h-5 mr-2" />
            WhatsApp NeatWave
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
